// @flow

// $FlowFixMe
import React, {useEffect} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {pick} from 'lodash';

import {reportError} from '@homeaway/react-error-reporter';

import withSearchBarLoadTime from '../Timing/withSearchBarLoadTime';
import {media} from '../../utils/breakpoints';
import type {Breakpoint} from '../../utils/breakpoints';
import ExpandedSearchBar from '../ExpandedSearchBar/ExpandedSearchBar';
import MobileSearchMegabox from '../MobileSearchMegabox/MobileSearchMegabox';
import ConnectedSkipToContentAnchor from '../ConnectedSkipToContent/ConnectedSkipToContentAnchor';

import type {SearchParamsType} from '../../reducers/searchParams';
import type {State as ReduxState} from '../../reducers/index';

import './SearchBar.less';

const paramsToLog = [
    'isBoundingBoxSearch',
    'legacyRegionPath',
    'pinnedPropertyListing',
    'q',
    'regionId',
    'searchTermUuid'
];

const systemDataToLog = ['isGoodBot', 'gtsQuery'];

// TODO: [TRAVOPS-1135] remove pathname upon adding "referer" to headers whitelist
// See https://jira.homeawaycorp.com/browse/TRAVOPS-1135
const logDataWhitelist = [...paramsToLog, ...systemDataToLog, 'pathname'];

type SystemDataToLog = {
    isGoodBot?: boolean,
    gtsQuery?: boolean
};

type StateProps = SearchParamsType &
    SystemDataToLog & {
        // TODO: [TRAVOPS-1135] remove pathname upon adding "referer" to headers whitelist
        pathname?: string,
        breakpoint: Breakpoint,
        hasTypeaheadSuggestionTerm: boolean
    };

export type Props = StateProps;

const useErrorReport = ({hasTypeaheadSuggestionTerm, logData}) => {
    useEffect(
        () => {
            if (!hasTypeaheadSuggestionTerm) {
                reportError({
                    name: 'typeahead suggestion term missing on load',
                    logData
                });
            }
        },
        // this tells effect to run only once when mounted
        [] // eslint-disable-line react-hooks/exhaustive-deps
    );
};

export const SearchBar = ({
    breakpoint,
    hasTypeaheadSuggestionTerm,
    ...rest
}: Props) => {
    useErrorReport({
        hasTypeaheadSuggestionTerm,
        logData: pick(rest, logDataWhitelist)
    });
    return (
        <div className="SearchBar">
            <ConnectedSkipToContentAnchor id="skipToSearchCriteria" />
            {!media(breakpoint, {
                minWidth: 'SM_MIN'
            }) ? (
                <div className="SearchBar__mobileMegabox visible-xs-block">
                    <MobileSearchMegabox />
                </div>
            ) : (
                <div className="SearchBar__expanded SearchBar__paddedChild hidden-xs">
                    <ExpandedSearchBar />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = ({
    searchParams: {params, pathname},
    system,
    typeaheadSuggestion,
    viewport
}: ReduxState): StateProps => ({
    breakpoint: viewport.breakpoint,
    hasTypeaheadSuggestionTerm: !!typeaheadSuggestion.term,
    pathname,
    ...pick(params, paramsToLog),
    ...pick(system, systemDataToLog)
});

export default compose(
    connect(mapStateToProps),
    withSearchBarLoadTime
)(SearchBar);
